import Vue from 'vue';

export default class AddressValidator {

    /**
     *
     * @param {Address} address
     */
    constructor(address, zipCodes) {
        this.errors = {};
        this.warnings = {};
        this.address = address;
        this.zipCodesList = zipCodes;
        this.validZip = true;
    }

    

    flushError(name) {
        return Vue.set(this.errors, name, '');
    }
    flushWarning(name) {
        return Vue.set(this.warnings, name, '');
    }

    validateName() {
        this.flushError('name');
        if(!this.address.name) {
            Vue.set(this.errors, 'name', 'page_setcontact.error.companymissing');
        }
    }

    validateMasterBrewer() {
        this.flushError('master_brewer');
        if(!this.address.master_brewer) {
            Vue.set(this.errors, 'master_brewer', 'page_setcontact.error.masterbrewermissing');
        }
    }

    validateAddress() {
        this.flushError('address');
        if(!this.address.street1 && !this.address.street2) {
            Vue.set(this.errors, 'address', 'page_setcontact.error.addressmissing');
        }
    }

    validateZip() {
        this.flushWarning('zip');
        if (!this.address.zip) { // Checks if this.address is undefined or null, and if this.address.zip is undefined or null
            Vue.set(this.warnings, 'zip', 'page_setcontact.error.zipmissing');
            return false;
        } else {
            var zipCodes = [];

            // Creates an array of allowed zipcodes depending on the selected country
            for (var i = 0; i < this.zipCodesList.length; i++) {
                if (this.zipCodesList[i].iso === this.address.country) {
                    zipCodes.push(this.zipCodesList[i]);
                }
            }
            
            if (zipCodes.length > 0) { // Check if zipCodes is an empty array or not
                for (var j = 0; j < zipCodes.length; j++) {
                    var regex = new RegExp(zipCodes[j].regex);
                    if (regex.test(this.address.zip)) {
                        this.validZip = true;
                        break; // break is used to exit the for loop once a match is found
                    } else {
                        this.validZip = false;
                    }
                }
            } else {
                // This zipCode not will be validated
                return true;
            }

            if (this.validZip) {
                return true;
            } else {
                Vue.set(this.warnings, 'zip', 'page_setcontact.error.zipinvalid');
                return false;
            }
        }
    }

    validateCity() {
        this.flushError('city');
        if(!this.address.city) {
            Vue.set(this.errors, 'city', 'page_setcontact.error.citymissing');
        }
    }

    validateCountry() {
        this.flushError('country');
        if(!this.address.country) {
            Vue.set(this.errors, 'country', 'page_setcontact.error.countrymissing');
        }
    }

    validateURL() {
        this.flushError('url');
        if(!this.address.url_company) {
            Vue.set(this.errors, 'url', 'page_setcontact.error.urlinvalid');
            return;
        }

        var urlRegex = /^(?:https?:\/\/)?(?:www\.)?(?:[\w-]+\.)+[a-z]{2,}$/;
        // Test if URL matches the regular expression
        if(!urlRegex.test(this.address.url_company)) {
            Vue.set(this.errors, 'url', 'page_setcontact.error.urlinvalid');
        }
    }

    

    validateAll() {
        this.validateName();
        this.validateAddress();
        this.validateCity();
        this.validateCountry();
        this.validateURL();

        Vue.set(this.errors, 'zip', ''); // Allows to click next while showing the warning message
    }
}